import { useMutation, useQueryClient } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT, RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';
import { useAuthStore } from '@/modules/user/stores';

import { CreateAuthorizedUserParams } from '../authorizedUsers.types';

import { GET_AUTHORIZED_USERS_KEY } from './useAuthorizedUsers.query';

const postAuthorizedUser = (params: CreateAuthorizedUserParams, employeeId: number) =>
  api.post(API_URL.AUTHORIZED_USERS, {
    employee_id: employeeId,
    first_name: params.firstName,
    last_name: params.lastName,
    relationship_type: params.relationshipType,
    birth_on: dayjs(params.birthOn, DEFAULT_DATE_FORMAT).format(RAW_DATE_FORMAT),
  });

const useCreateAuthorizedUserQuery = () => {
  const queryClient = useQueryClient();
  const { user } = useAuthStore();

  const { mutateAsync, isPending } = useMutation(
    (params: CreateAuthorizedUserParams) => postAuthorizedUser(params, Number(user?.employee?.id)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_AUTHORIZED_USERS_KEY] });
      },
    }
  );

  return {
    createAuthorizedUser: mutateAsync,
    isPending,
  };
};

export default useCreateAuthorizedUserQuery;
